export function mapToJson(map: Map<unknown, unknown> | null): string {
    if (!map) {
        return "";
    }
    return JSON.stringify(Array.from(map));
}
